import styled from "styled-components";

import { MacroTemplateContainer } from "../../styles";

export const CountdownTemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DesignContainer = styled(MacroTemplateContainer)`
  border-radius: 12px;
  overflow: hidden;
  padding: 24px 0px;
  cursor: pointer;

  & > div:first-child {
    width: 1000px;
    transform: translateX(24px);
  }
`;

export const OverviewCountdownTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const OverviewDesignContainer = styled.div`
  cursor: pointer;
  border-radius: ${({ borderRadius = 13 }) => borderRadius}px;
  height: fit-content;

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`};
`;
